/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  NetworkConfigurationContract,
  NetworkConfigurationContractInterface,
} from "../NetworkConfigurationContract";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_bootstrapContractRegistryAddress",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_authorisedUsers",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "_redbellyNodes",
        type: "address[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "registrationTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "jsonRpcPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "consensusPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "grpcPort",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "nodeAddress",
            type: "address",
          },
          {
            internalType: "address",
            name: "signingAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "hostname",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "exitTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct NetworkConfigurationInterface.NodeConfig[]",
        name: "_candidateNodes",
        type: "tuple[]",
      },
      {
        internalType: "bool",
        name: "_biasedReconfiguration",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "registrationTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "jsonRpcPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "consensusPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "grpcPort",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "nodeAddress",
            type: "address",
          },
          {
            internalType: "address",
            name: "signingAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "hostname",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "exitTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct NetworkConfigurationInterface.NodeConfig[]",
        name: "_bootStrapNodes",
        type: "tuple[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "Empty",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "IncorrectRegistrationFee",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nodeOperator",
        type: "address",
      },
    ],
    name: "CoolOffPeriodInitiated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "governorAddresses",
        type: "address[]",
      },
    ],
    name: "GovernorsUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "NodeConfigUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "NodeRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "NodeRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "isBiasedNetwork",
        type: "bool",
      },
    ],
    name: "ReconfigurationBiasnessUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "ACTIVITY_MONITOR_CONTRACT_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "GOVERNOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "IDP_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "JAILED_GOVERNORS_CONTRACT_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NETWORK_CONFIG_CONTRACT_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OWNER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE_FEED_AGGREAGATOR_CONTRACT_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "RECONFIGURATION_CONTRACT_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REDBELLY_NODE_OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REDBELLY_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "addCandidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "addGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "addRedbellyNodes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bootstrapContractsRegistry",
    outputs: [
      {
        internalType: "contract BootstrapContractsRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "deposits",
    outputs: [
      {
        internalType: "contract StakingDeposit",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getActiveCandidateNodes",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "getCandidateIndex",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCandidates",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCandidatesWithoutCooloffInitiated",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getGovernors",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getGovernorsToBeRemovedLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNetworkSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "getNodeConfiguration",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "registrationTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "jsonRpcPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "consensusPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "grpcPort",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "nodeAddress",
            type: "address",
          },
          {
            internalType: "address",
            name: "signingAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "hostname",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "exitTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct NetworkConfigurationInterface.NodeConfig",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "addresses",
        type: "address[]",
      },
    ],
    name: "getNodeConfigurationsByAddresses",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "registrationTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "jsonRpcPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "consensusPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "grpcPort",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "nodeAddress",
            type: "address",
          },
          {
            internalType: "address",
            name: "signingAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "hostname",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "exitTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct NetworkConfigurationInterface.NodeConfig[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "end",
        type: "uint256",
      },
    ],
    name: "getRandomIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nodeAddress",
        type: "address",
      },
    ],
    name: "isBootNode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "isCandidate",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "isGovernor",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "jailedGovernorsContract",
    outputs: [
      {
        internalType: "contract JailedGovernors",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "popBackGovernorsToBeRemoved",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "governorReplacementIndexes",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "candidateReplacementIndexes",
        type: "uint256[]",
      },
    ],
    name: "reconfigureNetwork",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "signingAddress",
        type: "address",
      },
      {
        internalType: "string",
        name: "hostname",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "jsonRpcPort",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "consensusPort",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "grpcPort",
        type: "uint256",
      },
    ],
    name: "register",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "registrationFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "removeCandidate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "removeGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "removeGovernorFromNetwork",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "feeAmount",
        type: "uint256",
      },
    ],
    name: "removeNode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "removeNodeDetailsFromNetwork",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddress",
        type: "address",
      },
    ],
    name: "removeRedbellyNodes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_updatedCoolOffPeriod",
        type: "uint256",
      },
    ],
    name: "setCoolOffPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "biasReconfiguration",
        type: "bool",
      },
    ],
    name: "setReconfigurationBiasness",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "signingAddressToNodeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tombstonedGovernorsContract",
    outputs: [
      {
        internalType: "contract TombstonedGovernors",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "nodeAddr",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "registrationTimestamp",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "jsonRpcPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "consensusPort",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "grpcPort",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "nodeAddress",
            type: "address",
          },
          {
            internalType: "address",
            name: "signingAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "hostname",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "exitTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct NetworkConfigurationInterface.NodeConfig",
        name: "_nodeConfig",
        type: "tuple",
      },
    ],
    name: "updateCandidateConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_registrationFee",
        type: "uint256",
      },
    ],
    name: "updateRegistrationFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_threshold",
        type: "uint256",
      },
    ],
    name: "updateTombstoneThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class NetworkConfigurationContract__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _bootstrapContractRegistryAddress: string,
    _authorisedUsers: string[],
    _redbellyNodes: string[],
    _candidateNodes: {
      registrationTimestamp: BigNumberish;
      id: BigNumberish;
      jsonRpcPort: BigNumberish;
      consensusPort: BigNumberish;
      grpcPort: BigNumberish;
      nodeAddress: string;
      signingAddress: string;
      hostname: string;
      exitTimestamp: BigNumberish;
    }[],
    _biasedReconfiguration: boolean,
    _bootStrapNodes: {
      registrationTimestamp: BigNumberish;
      id: BigNumberish;
      jsonRpcPort: BigNumberish;
      consensusPort: BigNumberish;
      grpcPort: BigNumberish;
      nodeAddress: string;
      signingAddress: string;
      hostname: string;
      exitTimestamp: BigNumberish;
    }[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<NetworkConfigurationContract> {
    return super.deploy(
      _bootstrapContractRegistryAddress,
      _authorisedUsers,
      _redbellyNodes,
      _candidateNodes,
      _biasedReconfiguration,
      _bootStrapNodes,
      overrides || {}
    ) as Promise<NetworkConfigurationContract>;
  }
  getDeployTransaction(
    _bootstrapContractRegistryAddress: string,
    _authorisedUsers: string[],
    _redbellyNodes: string[],
    _candidateNodes: {
      registrationTimestamp: BigNumberish;
      id: BigNumberish;
      jsonRpcPort: BigNumberish;
      consensusPort: BigNumberish;
      grpcPort: BigNumberish;
      nodeAddress: string;
      signingAddress: string;
      hostname: string;
      exitTimestamp: BigNumberish;
    }[],
    _biasedReconfiguration: boolean,
    _bootStrapNodes: {
      registrationTimestamp: BigNumberish;
      id: BigNumberish;
      jsonRpcPort: BigNumberish;
      consensusPort: BigNumberish;
      grpcPort: BigNumberish;
      nodeAddress: string;
      signingAddress: string;
      hostname: string;
      exitTimestamp: BigNumberish;
    }[],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _bootstrapContractRegistryAddress,
      _authorisedUsers,
      _redbellyNodes,
      _candidateNodes,
      _biasedReconfiguration,
      _bootStrapNodes,
      overrides || {}
    );
  }
  attach(address: string): NetworkConfigurationContract {
    return super.attach(address) as NetworkConfigurationContract;
  }
  connect(signer: Signer): NetworkConfigurationContract__factory {
    return super.connect(signer) as NetworkConfigurationContract__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NetworkConfigurationContractInterface {
    return new utils.Interface(_abi) as NetworkConfigurationContractInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NetworkConfigurationContract {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as NetworkConfigurationContract;
  }
}
